import { call, put, takeLatest } from 'redux-saga/effects';
import CUSTOM_CERT_TYPES from './_actionTypes';
import {
  uploadExcelSuccess,
  uploadExcelFailure,
  fetchJobStatusSuccess,
  fetchJobStatusFailure,
  fetchJobsListSuccess,
  fetchJobsListFailure,
} from './_actions';
import CustomCertificatesHelper from '../../../../utils/API/BackendHelper/admin/customCertificates';

function* uploadExcelSaga(action) {
  try {
    const response = yield call(CustomCertificatesHelper.uploadExcel, action.payload.file);
    if (response.success) {
      // Normalize upload response (API returns camelCase) to match poll-status shape
      const normalized = {
        id: response.data.jobId,
        total_records: response.data.totalRecords,
        processed_records: 0,
        failed_records: 0,
        status: 'pending',
        created_at: new Date().toISOString(),
        filename: action.payload.file?.name || null,
      };
      yield put(uploadExcelSuccess(normalized));
    } else {
      yield put(uploadExcelFailure(response.message || 'Upload failed'));
    }
  } catch (error) {
    yield put(uploadExcelFailure(error.message || 'Upload failed'));
  }
}

function* fetchJobStatusSaga(action) {
  try {
    const response = yield call(CustomCertificatesHelper.getJobStatus, action.payload.jobId);
    if (response.success) {
      yield put(fetchJobStatusSuccess(response.data));
    } else {
      yield put(fetchJobStatusFailure(response.message || 'Failed to fetch job status'));
    }
  } catch (error) {
    yield put(fetchJobStatusFailure(error.message || 'Failed to fetch job status'));
  }
}

function* fetchJobsListSaga() {
  try {
    const response = yield call(CustomCertificatesHelper.getJobsList);
    if (response.success) {
      yield put(fetchJobsListSuccess(response.data));
    } else {
      yield put(fetchJobsListFailure(response.message || 'Failed to fetch jobs'));
    }
  } catch (error) {
    yield put(fetchJobsListFailure(error.message || 'Failed to fetch jobs'));
  }
}

export default function* customCertificatesSaga() {
  yield takeLatest(CUSTOM_CERT_TYPES.UPLOAD_EXCEL_REQUEST, uploadExcelSaga);
  yield takeLatest(CUSTOM_CERT_TYPES.FETCH_JOB_STATUS_REQUEST, fetchJobStatusSaga);
  yield takeLatest(CUSTOM_CERT_TYPES.FETCH_JOBS_LIST_REQUEST, fetchJobsListSaga);
}
